import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, isRef as _isRef, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3cbe6351"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "home_box" }

import { onMounted, reactive, ref, watch } from "vue";
import { api_cw_get_finance_list, api_cw_balance_inquiry, api_cw_pay_check, api_cw_select_trade } from '@/api/home';
import { message, type TableColumnsType } from 'ant-design-vue';

import { ReloadOutlined, DownloadOutlined } from '@ant-design/icons-vue';
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import type { Dayjs } from 'dayjs';
// 局部引入
import * as XLSX from 'xlsx';
import FileSaver from 'file-saver';

type RangeValue = [Dayjs, Dayjs];

export default /*#__PURE__*/_defineComponent({
  __name: 'dataStatistics',
  setup(__props) {

const value1 = ref<RangeValue | null>();
let current = ref<number>(1)
let user: any = localStorage.getItem('user') || sessionStorage.getItem('user');
let res = ref<any>(null)
user = JSON.parse(user);

let sort = ref<string>('desc');
let c_type = ref<string>('');
let date = ref<string[]>([]);

watch(value1, (newValue, oldValue) => {
    if (newValue === null) {
        list.value = [];
        current.value = 1;
        total.value = 1;
    }
})

let packageNo = ref('');

onMounted(() => {
    console.log('组件加载');
    // api_cw_balance_inquiryFun();
    api_cw_select_tradeFun();
    finishFun('');
});




const resetFun = () => {
    current.value = 1;
    sort.value = 'desc';
    c_type.value = '';
    date.value = [];
    // pickerChangeFun(null);
    value1.value = null;
    finishFun('');
}




const dateFun = (timestamp: number): string => {
    console.log(timestamp);
    var date = new Date(timestamp);
    var year = date.getFullYear();
    var month = (date.getMonth() + 1).toString().padStart(2, '0');
    var day = date.getDate().toString().padStart(2, '0');
    var Hours = date.getHours();
    var Minutes = date.getMinutes()
    return `${year}${month}${day}${Hours}${Minutes}00`
}



const TheInverseDateFun = (str: string): string => {
    let year = str.slice(0, 4) + '年';
    let month = str.slice(4, 6) + '月';
    let day = str.slice(6, 8) + '日';
    let hour = str.slice(8, 10) + '时';
    let minute = str.slice(10, 12) + '分';
    let second = str.slice(12, 14) + '秒';
    return year + month + day + hour + minute + second
}



const api_cw_select_tradeFun = async () => {


}

const handleChange = (e: any) => {
    console.log(e);
}
const focus = (e: any) => {
    console.log(e);
}
const paginationChange = (e: number) => {
    current.value = e;
    finishFun('1');
}



let usableBalance = ref(0);
let balance = ref(0);
let lastDayBalance = ref(0);

const open = ref<boolean>(false);


const showModal = () => {
    open.value = true;
};

const handleOk = (e: MouseEvent) => {
    console.log(e);
    open.value = false;
};













const api_cw_balance_inquiryFun = async () => {
    let data: any = await api_cw_balance_inquiry(user.payAccNo, user.openid);
    usableBalance.value = data.usableBalance
    balance.value = data.balance
    lastDayBalance.value = data.lastDayBalance
    console.log(data);

}

const columns: TableColumnsType = [
    { title: '转账账号', width: 100, dataIndex: 'recAccNo' },
    { title: '开户名', width: 100, dataIndex: 'recAccName' },
    // { title: '银行名称', width: 100, dataIndex: 'recBankName' },
    { title: '转账金额', width: 100, dataIndex: 'amount' },
    { title: '状态', width: 100, dataIndex: 'drcType' },
    { title: '订单号', width: 100, dataIndex: 'retNo' },
    { title: '操作时间', width: 100, dataIndex: 'tranTime' },
    // { title: '操作', width: 100, dataIndex: 'Controls' }
];

const columnss: TableColumnsType = [
    { title: '转账账号', width: "30%", dataIndex: 'recAccNo' },
    { title: '转账金额', width: "15%", dataIndex: 'amount' },
    { title: '转账状态', width: "30%", dataIndex: 'desc' },
]

let list: any = ref([]);
let dataSource: any = []

let total: any = ref(1);
let arr: any = ref([])
const finishFun = async (value: any = '') => {
    console.log(value);
    if (value !== '1') current.value = 1
    arr.value = [];
    let up = null
    if (value === 2) {
        arr.value = []
        up = {
            openid: user.openid,
            export: 1,
            page: current.value,
            sort: sort.value,  //排序  asc   desc
            beginDate: date.value[0], //开始时间
            endDate: date.value[1],   //结束时间
            c_type: c_type.value //C  收入   D支出   不传  就是全部  
        }
        const data: any = await api_cw_select_trade(up);
        console.log(data);
        data.list.forEach((item: any) => {
            console.log(item);
            let obj: any = {}
            for (let key in item) {
                console.log(key);
                switch (true) {
                    case key === 'amount':
                        obj['转账金额'] = item['amount']
                        break;
                    case key === 'recAccName':
                        obj['开户名'] = item['recAccName']
                        break;
                    case key === 'recAccNo':
                        obj['转账账号'] = item['recAccNo']
                        break;
                    case key === 'retNo':
                        obj['订单号'] = item['retNo']
                        break;
                    case key === 'drcType':
                        obj['状态'] = item['drcType']
                        break;
                    case key === 'tranTime':
                        item.tranTime = TheInverseDateFun(item.tranTime);
                        obj['操作时间'] = item['tranTime']
                        break;
                }
            }



            arr.value.push(obj)
        })
        console.log(arr);
        const ws = XLSX.utils.json_to_sheet(arr.value);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
        function s2ab(s: any) {

            const buf = new ArrayBuffer(s.length);
            const view = new Uint8Array(buf);
            console.log(view);
            for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
            return buf;
        }
        FileSaver.saveAs(new Blob([s2ab(wbout)], { type: 'application/octet-stream' }), `${data.dc_time}导出明细.xlsx`);
    } else {
        list.value = []
        up = {
            openid: user.openid,
            page: current.value,
            sort: sort.value,  //排序  asc   desc
            beginDate: date.value[0], //开始时间
            endDate: date.value[1],   //结束时间
            c_type: c_type.value //C  收入   D支出   不传  就是全部  
        }
        const data: any = await api_cw_select_trade(up);
        console.log(data);
        res.value = data;
        if (data.error !== 0) {
            message.error('暂无数据！！！')
            return
        }
        total.value = data.total * 1;
        data.list.forEach((item: any) => {
            item.tranTime = TheInverseDateFun(item.tranTime);
            list.value.push(item);
        });
    }

}


let pickerChangeFun = (e: any) => {
    console.log(e);

    if (e === null) return
    if (date.value.length === 2) {
        date.value = []
    }
    for (let index = 0; index < e.length; index++) {
        const element = e[index].$d;

        let str: string = dateFun(Date.parse(element))
        date.value.push(str);
    }
}

const StatusQueryFun = async (item: any) => {
    console.log(item);
    dataSource.value = [];

    let up = {
        openid: user.openid,
        queryPacNo: item.packageNo
    }
    console.log(up);

    let data: any = await api_cw_pay_check(up);
    if (data.header.code === '000000') {
        open.value = true;
        data.body.details.forEach((item: any) => {

            let obj = {
                recAccNo: item.recAccNo,
                amount: item.amount / 100,
                desc: item.desc
            }
            dataSource.value.push(obj);
        });
        console.log(dataSource.value);
    }






}



return (_ctx: any,_cache: any) => {
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(res) !== null)
      ? (_openBlock(), _createBlock(_component_a_descriptions, {
          key: 0,
          bordered: "",
          size: "small",
          column: 2
        }, {
          extra: _withCtx(() => [
            _createVNode(_component_a_space, {
              direction: "vertical",
              style: {"margin":"0 20px"}
            }),
            _createVNode(_component_a_form, { layout: "inline" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_range_picker, {
                      value: value1.value,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((value1).value = $event)),
                      "show-time": { format: 'HH:mm' },
                      locale: _unref(locale),
                      format: "YYYY-MM-DD HH:mm",
                      onChange: _unref(pickerChangeFun)
                    }, null, 8, ["value", "locale", "onChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio_group, {
                      value: _unref(sort),
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_isRef(sort) ? (sort).value = $event : sort = $event)),
                      "button-style": "solid"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio_button, { value: "asc" }, {
                          default: _withCtx(() => [
                            _createTextVNode("升序")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_radio_button, { value: "desc" }, {
                          default: _withCtx(() => [
                            _createTextVNode("降序")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      ref: "select",
                      value: _unref(c_type),
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_isRef(c_type) ? (c_type).value = $event : c_type = $event)),
                      style: {"width":"100px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select_option, { value: "" }, {
                          default: _withCtx(() => [
                            _createTextVNode("全部")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: "D" }, {
                          default: _withCtx(() => [
                            _createTextVNode("支出")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: "C" }, {
                          default: _withCtx(() => [
                            _createTextVNode("收入")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: finishFun
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("搜索")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (finishFun(2)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(DownloadOutlined)),
                        _createTextVNode("导出 ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: resetFun
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ReloadOutlined))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_descriptions_item, { label: "总收入" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(res).all_sr), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "总支出" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(res).all_zc), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "手续费" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(res).all_rate), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "收入笔数" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(res).sr_count), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "支出笔数" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(res).zc_count), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "余额" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(res).balance), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_table, {
        class: "components-table-demo-nested",
        columns: columns,
        "data-source": _unref(list),
        scroll: { y: 350 },
        pagination: false
      }, {
        bodyCell: _withCtx(({ column, record }) => [
          (column.dataIndex === 'Controls')
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                type: "primary",
                onClick: ($event: any) => (StatusQueryFun(record))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("查询状态")
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["data-source"]),
      _createVNode(_component_a_pagination, {
        style: {"margin-top":"20px"},
        current: _unref(current),
        "onUpdate:current": _cache[4] || (_cache[4] = ($event: any) => (_isRef(current) ? (current).value = $event : current = $event)),
        simple: "",
        total: _unref(total),
        onChange: paginationChange,
        pageSize: 10,
        hideOnSinglePage: false
      }, null, 8, ["current", "total"])
    ]),
    _createVNode(_component_a_modal, {
      open: open.value,
      "onUpdate:open": _cache[5] || (_cache[5] = ($event: any) => ((open).value = $event)),
      width: "800px",
      title: "查询状态",
      onOk: handleOk,
      footer: null
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_table, {
          columns: columnss,
          scroll: { y: 300 },
          pagination: false,
          "data-source": _unref(dataSource)
        }, null, 8, ["data-source"])
      ]),
      _: 1
    }, 8, ["open"])
  ]))
}
}

})